import React from 'react';
import { Navbar } from '../components/landing/Navbar';
import { Hero } from '../components/landing/Hero';
import { Problem } from '../components/landing/Problem';
import { Solution } from '../components/landing/Solution';
import { CaseStudy } from '../components/landing/CaseStudy';
import { Features } from '../components/landing/Features';
import { ForResorts } from '../components/landing/ForResorts';
import { ForAgencies } from '../components/landing/ForAgencies';
import { AgencySignup } from '../components/landing/AgencySignup';
import { BusinessModel } from '../components/landing/BusinessModel';
import { AICapabilities } from '../components/landing/AICapabilities';
import { Roadmap } from '../components/landing/Roadmap';
import { CTASection } from '../components/landing/CTASection';
import { Footer } from '../components/landing/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-stone-50 font-sans text-stone-900" data-id="element-1603">
      <Navbar data-id="element-1604" />
      <main data-id="element-1605">
        <Hero data-id="element-1606" />
        <Problem data-id="element-1607" />
        <Solution data-id="element-1608" />
        <CaseStudy data-id="element-1609" />
        <Features data-id="element-1610" />
        <ForResorts data-id="element-1611" />
        <ForAgencies data-id="element-1612" />
        <AgencySignup data-id="element-1613" />
        <BusinessModel data-id="element-1614" />
        <AICapabilities data-id="element-1615" />
        <Roadmap data-id="element-1616" />
        <CTASection data-id="element-1617" />
      </main>
      <Footer data-id="element-1618" />
    </div>;
}